import CreateAccessProfile from './CreateAccessProfile';

export default CreateAccessProfile;
